import React, { useState } from "react";
import NavigationSidebar from "../../components/Dashboard/NavigationSidebar";
import SummaryCard from "../../components/Dashboard/SummaryCard";
import ChartCard from "../../components/Dashboard/ChartCard";
import "../../styles/SuperadminDashboard.css";
import { useNavigate } from "react-router-dom";

export default function SuperadminDashboard() {
  const [activeNav, setActiveNav] = useState("Dashboard");
  const navigate = useNavigate();

  const summaryCards = [
    { title: "Total Clinics", value: "10" },
    { title: "Total Users", value: "25" },
    { title: "New Clinics", value: "1", hasDropdown: true, dropdownLabel: "Today" },
  ];

  const analysisCards = [
    { title: "Conversion Rate (Demo → Setup)", value: "12%" },
    { title: "Total AI Chats", value: "3678", hasDropdown: true, dropdownLabel: "Today" },
    { title: "Avg AI Chat per Clinic", value: "685" },
  ];

  const chartDropdownOptions = {
    "Total AI Chats Per Day": [
      "Last 7 Days",
      "Last 30 Days",
      "Current Week",
      "Current Month",
      "Current Year",
      "Last Year",
    ],
    "Clinics by AI Chat Volume Share": [
      "Top 5",
      "Top 10",
      "Top 15",
      "Top 20",
    ],
    "Clinics ranked by AI Chats this month": [
      "Top 50",
      "Top 50–100",
      "Top 100–150",
      "Top 150–200",
      "200 and after",
    ],
    "Clinics by Locations": [
      "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
      "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois",
      "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland",
      "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana",
      "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York",
      "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
      "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah",
      "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
    ],
    "Clinic Count By Plan Tier Per Day": [
      "Last 7 Days",
      "Last 30 Days",
      "Current Week",
      "Current Month",
      "Current Year",
      "Last Year",
    ],
  };

  const charts = [
    { title: "Total AI Chats Per Day", image: "/Chart1.png" },
    { title: "Clinics by AI Chat Volume Share", image: "/Chart2.png" },
    { title: "Clinics ranked by AI Chats this month", image: "/Bar-Chart.png" },
    { title: "Clinics by Locations", image: "/clinic-map.png" },
    { title: "Clinic Count By Plan Tier Per Day", image: "/stacked-chart.png" },
  ];

  return (
    <div className="dashboard-container">
      <NavigationSidebar activeNav={activeNav} setActiveNav={setActiveNav} />

      <div className="dashboard-content">
        <div className="dashboard-header">
          <h1 className="dashboard-title">Dashboard</h1>
          <button className="add-clinic-btn" onClick={() => navigate("/admin/create-clinic")}>
              + Add New Clinic
          </button>
        </div>

        <div className="summary-title">Summary</div>
        <hr />

        <div className="card-grid">
          {summaryCards.map((card, i) => (
            <SummaryCard key={i} {...card} />
          ))}
        </div>

        <div className="card-grid">
          {analysisCards.map((card, i) => (
            <SummaryCard key={i} {...card} />
          ))}
        </div>

        <div className="summary-title">Analysis</div>
        <hr />

        <div className="chart-grid">
          {charts.map((chart, i) => (
            <ChartCard
              key={i}
              title={chart.title}
              dropdownOptions={chartDropdownOptions[chart.title]}
            >
              <img src={chart.image} alt={chart.title} />
            </ChartCard>
          ))}
        </div>
      </div>
    </div>
  );
}
